import React, { Fragment } from "react"
import { Table, TableIcon } from "../../UI/Table/Table"

const VerifyInsurance = ({values}) => {
  const { insurance } = values

  const RenderInsurance = () => {
    if (insurance) {
      return (
        <td>
          Ja, ich möchte eine Reiserücktrittskostenversicherung abschließen.
        </td>
      )
    }

    return (
      <td>
        Nein, ich möchte keine Reiserücktrittskostenversicherung abschließen.
      </td>
    )
  }

  return (
    <Fragment>
      <Table  
        hasError={null}
        headline="Reiserücktrittskostenversicherung"
      >
        <tr>
          <td width="15%">
            <TableIcon type={insurance ? "check" : "cross"} />
          </td>
          <RenderInsurance />
        </tr>
      </Table>
    </Fragment>
  )
}

export default VerifyInsurance